import React from "react";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { isString } from "generic-type-guard";

import { ExternalLink, HintTooltipProps } from "@com.mgmtp.a12.widgets/widgets-core";
import { Tooltip } from "@com.mgmtp.a12.widgets/widgets-core/lib/tooltip";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button";
import { Icon } from "@com.mgmtp.a12.widgets/widgets-core/lib/icon";
import { A11YLanguageContext } from "@com.mgmtp.a12.widgets/widgets-core/lib/common/main/a11y-localization";
import { provider } from "@com.mgmtp.a12.widgets/widgets-core/lib/common";

import { MultilineString } from "./MultilineString";

export interface ModulFLink {
	readonly link: string;
	readonly linkText: string;
}

export const ModulFLinkContext = React.createContext<ModulFLink[] | undefined>(undefined);

export const CustomHintTooltip: React.ComponentType<HintTooltipProps> = function CustomHintTooltip(props) {
	const { tooltipTitles } = React.useContext(A11YLanguageContext);
	const links = React.useContext(ModulFLinkContext);
	const tooltipTitleByVariant = tooltipTitles?.hintTrigger;
	const a11yTitle =
		provider.get() === "phone"
			? tooltipTitleByVariant
			: `${tooltipTitleByVariant}: ${tooltipTitles?.triggerElement}`;

	const text = React.useMemo(() => {
		if (isString(props.text)) {
			if (links) {
				return (
					<>
						<MultilineString
							text={
								props.text.length == 2 && props.text.includes("\\n")
									? "Link(s):"
									: props.text + "\\n \\n Link(s):"
							}
						/>
						{links.map(m => (
							<React.Fragment key={m.linkText}>
								<br />
								<ExternalLink href={sanitizeUrl(m.link)}>{m.linkText}</ExternalLink>
							</React.Fragment>
						))}
					</>
				);
			}
			return <MultilineString text={props.text} />;
		}
		return props.text;
	}, [props.text, links]);
	return (
		<Tooltip
			text={text}
			disabled={props.disabled}
			className={props.className}
			style={props.style}
			id={props.id}
			dataRole={props.dataRole || "tooltip-hint"}
			variant="hint"
		>
			<Button
				disabled={props.disabled}
				icon={
					<Icon iconTheme="outlined" showTitleAsTooltip={false} title={a11yTitle}>
						info
					</Icon>
				}
				invert={props.invert}
			/>
		</Tooltip>
	);
};
